import { Component, OnInit } from '@angular/core';
import { MpsUserService } from '../../../../../mps/mps-auth';
import {User} from 'src/app/models/user';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
    authUser: User;
    
    constructor(
        private userService: MpsUserService,
    ) { }

    ngOnInit(): void {
        this.authUser = new User(this.userService.getUser().getValue());
    }
}
